module.exports = __webpack_public_path__ + "img/horizontal_7_4_pp1_8017.c0e68bbe.png";